export const salesTeamMemberFeatureKey = 'salesTeamMember';

export type SalesTeamMember = {
  id: number;
  salesTeamId: number;
  userId: number;
  userContactName: string;
  userAspNetUserEmailConfirmed: boolean;
};
